import { render, staticRenderFns } from "./EntityButtons.vue?vue&type=template&id=745103d4&scoped=true&"
import script from "./EntityButtons.vue?vue&type=script&lang=js&"
export * from "./EntityButtons.vue?vue&type=script&lang=js&"
import style0 from "./EntityButtons.vue?vue&type=style&index=0&id=745103d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745103d4",
  null
  
)

export default component.exports